import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from "../../../../core/service/v2/service/action/abstractAction.service";
import {DocumentModel} from "../model/document.model";
import {CustomizeHttpUrlGenerator} from "../../../../../store/core/url/customizeHttpUrlGenerator";
import {DocumentConverter} from "../converter/document.converter";
import {Payload} from "../../../../core/service/payload/payload";
import {Moment} from "moment";

@Injectable()
export class DocumentSignActionService
    extends AbstractActionService<DocumentSignPayload, DocumentModel> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient,
                       private converter: DocumentConverter) {
        super('Document', 'sign', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): DocumentModel {
        return this.converter.convert(response);
    }
}

export class DocumentSignPayload implements Payload{
    id?: number;
    publicId?: string;
    signatureBase64: string;
    name: string;
    email:string;
    date: Moment;
}
